<p-sidebar position="left" [autoZIndex]="false" [visible]="(isMenuVisible$ | async) === false && !isWindowOpen" [showCloseIcon]="false"
  [modal]="false" styleClass="ice-pop-layout-sidebar mobile">
  <div class="m-menu-container">
    <div class="m-menu-main-container">
      <div class="m-menu-header">
        <div>
          <a href="javascript: void(0)" class="m-menu-back-button" (click)="toggleSideMenu()">
            <img src="./assets/images/ic-back-m.svg" />
          </a>
          <p-avatar image="./assets/images/sample-avatar.png" shape="circle"></p-avatar>
          <span class="ml-15">{{ userInfoDisplay }}</span>
        </div>
        <button pButton pRipple type="button" label="Log Out" class="p-button-rounded p-button-outlined m-menu-button"
          (click)="logout()"></button>
      </div>
      <ul class="m-menu-list">
        <p-accordion [collapseIcon]="'pi pi-angle-up'" [expandIcon]="'pi fw pi-chevron-down'" styleClass="menu-accordion">
          <p-accordionTab>
            <ng-template pTemplate="header">{{ this.locale | optionsMapping : languageOptions }}</ng-template>
            <ng-template pTemplate="content">
              <ul class="m-menu-list">
                <li *ngFor="
                  let language of languageOptions;
                  let languageIndex = index
                " class="m-menu-list-item p-p-0">
                  <a href="javascript: void(0)" class="m-menu-sub-list-link" (click)="onLanguageChange(language.value)">
                    {{ language.label }}
                  </a>
                </li>
              </ul>
            </ng-template>
          </p-accordionTab>
        </p-accordion>



        <!-- <li class="m-menu-list-item">
          <a
            href="#"
            class="m-menu-list-link has-sub"
            (click)="onMobileSubMenuOpen('language')"
          >
            {{ this.locale | optionsMapping : languageOptions }}
          </a>
          <div
            class="m-menu-sub-container"
            [ngClass]="{ active: currentMenuItem === 'language' }"
          >
            <div class="m-menu-sub-title">
              <div>
                <a
                  href="#"
                  class="m-menu-back-button"
                  (click)="onMobileSubMenuClose()"
                >
                  <img src="./assets/images/ic-back-m.svg" />
                </a>
                {{ "Common.Label.Language" | translate }}
              </div>
            </div>
            <ul class="m-menu-sub-list">
              <li
                *ngFor="
                  let language of languageOptions;
                  let languageIndex = index
                "
                class="m-menu-sub-item"
              >
                <a
                  href="javascript: void(0)"
                  class="m-menu-sub-list-link"
                  (click)="onLanguageChange(language.value)"
                >
                  {{ language.label }}
                </a>
              </li>
            </ul>
          </div>
        </li> -->
        <li *ngIf="
          userProfile?.extranetUserRole === 1 ||
          userProfile?.extranetUserRole === 2
        " class="m-menu-list-item">
          <a href="#" class="m-menu-list-link has-sub" (click)="onMobileSubMenuOpen('changePassword')">
            {{ "Login.ChangePassword" | translate }}
          </a>

          <div class="m-menu-sub-container" [ngClass]="{ active: currentMenuItem === 'changePassword' }">
            <div class="m-menu-sub-title">
              <div>
                <a href="#" class="m-menu-back-button" (click)="onMobileSubMenuClose()">
                  <img src="./assets/images/ic-back-m.svg" />
                </a>
                {{ "Login.ChangePassword" | translate }}
              </div>
            </div>
            <sigv-password-change-form (changePasswordResult)="onPasswordChange($event)"></sigv-password-change-form>
          </div>
        </li>
        <li *ngFor="let menuItem of displayMenus; index as i" class="m-menu-list-item">
          <a href="javascript: void(0)" class="m-menu-list-link" (click)="onMobileMenuItemClick(menuItem)">
            <img [src]="(envConfig.iconSrcUrl + '/' +  menuItem.icon + '.svg') | iconSource | async"
              [class.m-menu-icon-highlight]="menuItem.icon === 'ExWebSubmission_ExSubmission_ExAdd'" />
            {{ menuItem.label || "" }}
            <div *ngIf="menuItem.count" class="badge" [class.low]="(menuItem.count || 0) < 10" [class.medium]="
                (menuItem.count || 0) >= 10 &&
                (menuItem.count || 0) < 20
              " [class.high]="(menuItem.count || 0) >= 20">
              {{ menuItem.count }}
            </div>
          </a>
          <div class="m-menu-sub-container" *ngIf="menuItem.items && menuItem.items.length > 0"
            [ngClass]="{ active: currentMenuItem === menuItem.srcLabel }">
            <div class="m-menu-sub-title">
              <div>
                <a href="javascript: void(0)" class="m-menu-back-button" (click)="onMobileSubMenuClose(menuItem)">
                  <img src="./assets/images/ic-back-m.svg" />
                </a>
                {{ menuItem.label || "" }}
              </div>
            </div>
            <ul class="m-menu-sub-list">
              <li *ngFor="let item of menuItem.items; index as i" class="m-menu-sub-item">
                <a href="javascript: void(0)" class="m-menu-sub-list-link" (click)="onMobileNavLinkClick(item)">
                  <img [src]="(envConfig.iconSrcUrl + '/' +  item.icon + '.svg') | iconSource | async" width="24"
                    height="24" />
                  {{ item.label || "" }}
                  <div *ngIf="item.count" class="badge" [class.low]="(item.count || 0) < 10" [class.medium]="
                      (item.count || 0) >= 10 &&
                      (item.count || 0) < 20
                    " [class.high]="(item.count || 0) >= 20">
                    {{ item.count }}
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</p-sidebar>

<p-sidebar position="left" [autoZIndex]="false" [visible]="(isMenuVisible$ | async) === true" [showCloseIcon]="false"
  [modal]="false" styleClass="ice-pop-layout-sidebar desktop">
  <div class="ice-pop-container">
    <ul class="ice-pop-item-list">
      <li *ngFor="let menuItem of displayMenus; index as i"
        class="ice-pop-item p-d-flex p-flex-column p-align-center p-jc-center"
        [class.ice-pop-todo]="menuItem.items && menuItem.items.length > 0"
        [class.multi-layer]="menuItem.items && menuItem.items.length > 0">
        <a *ngIf="menuItem.entryUrl; else withoutLink" href="javascript: void(0)" (click)="onNavLinkClick(menuItem)">
          <div class="ice-pop-logo" [class.ice-pop-highlight]="menuItem.icon === 'ExWebSubmission_ExSubmission_ExAdd'">
            <img [src]="(envConfig.iconSrcUrl + '/' + menuItem.icon + '.svg') | iconSource | async" />
            <div class="ice-pop-unread" *ngIf="menuItem.count">
              {{ menuItem.count }}
            </div>
          </div>
        </a>
        <ng-template #withoutLink>
          <div class="ice-pop-logo">
            <img [src]="(envConfig.iconSrcUrl + '/' +  menuItem.icon + '.svg') | iconSource | async" />
            <div class="ice-pop-unread" *ngIf="menuItem.count">
              {{ menuItem.count }}
            </div>
          </div>
        </ng-template>
        <div class="ice-pop-title">{{ menuItem.label || "" }}</div>
        <div *ngIf="menuItem.items && menuItem.items.length > 0"
          class="ice-pop-layer2-tab p-d-flex p-flex-row p-jc-end p-ai-start">
          <ul class="ice-pop-layer2-list p-d-flex p-flex-column">
            <li *ngFor="let item of menuItem.items"
              class="ice-pop-layer2-item p-d-flex p-flex-row p-ai-center p-jc-start" (click)="onNavLinkClick(item)">
              <img [src]="(envConfig.iconSrcUrl + '/' +  item.icon + '.svg') | iconSource | async" width="24"
                height="24" />
              <span>{{ item.label }}</span>
              <div *ngIf="item.count">
                {{ item.count }}
              </div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</p-sidebar>
